/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placefollowflyerheadline3Inputs */

const en_placefollowflyerheadline3 = /** @type {(inputs: Placefollowflyerheadline3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Follow us on Pulsify`)
};

const de_placefollowflyerheadline3 = /** @type {(inputs: Placefollowflyerheadline3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Folg uns auf Pulsify`)
};

/**
* | output |
* | --- |
* | "Follow us on Pulsify" |
*
* @param {Placefollowflyerheadline3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placefollowflyerheadline3 = /** @type {((inputs?: Placefollowflyerheadline3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placefollowflyerheadline3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placefollowflyerheadline3(inputs)
	return de_placefollowflyerheadline3(inputs)
});
export { placefollowflyerheadline3 as "placeFollowFlyerHeadline" }